export { default } from './HoldsPauseDateLink';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsPauseDateLink/index.js